import React, { useEffect, useState } from "react";
import { Radio, Switch } from "@material-ui/core";
import { LiaAwardSolid, LiaMoneyBillWaveSolid } from "react-icons/lia";
import { GoArrowLeft } from "react-icons/go";
import {
    IoCalendarOutline,
    IoClose,
    IoCloseSharp,
    IoLockClosedOutline,
} from "react-icons/io5";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const ShareSetting = ({
    close,
    setMarkupValue,
    selectedValue,
    setSelectedValue,
    markupError,
    markupValue,
    onBack,
    setPayload,
    data,
    mount,
    setMount,
    setStartDate,
    startDate,
    setPassword,
    setFinalPayload,
    setMarkupType,
    markupType,
    certificateEnabled,
    setCertificateEnabled
}) => {

    function handleChange(event) {
        setSelectedValue(event.target.value);
    }

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-sm px-2 btn-clear btn-hover-bg-light mr-2"
                        onClick={onBack}
                    >
                        <GoArrowLeft className="font-size-h4" />
                    </button>
                    <div className="d-flex flex-column align-items-start">
                        <span className=" font-size-h5 font-weight-bold">
                            Share Settings
                        </span>
                        <span className="text-muted font-weight-bold">
                            {data?.shape} {data?.carat ? `${data?.carat.toFixed(2)}ct` : null} {data?.color}{" "}
                            {data?.clarity} {data?.cut} {data?.polish}{" "}
                            {data?.symmetry} {data?.fluorescence}
                        </span>
                    </div>
                </div>
                <button
                    className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1"
                    onClick={close}
                >
                    <IoCloseSharp
                        className=" font-size-h4 text-muted"
                        size={18}
                    />
                </button>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="font-weight-bold mt-4">
                        Certificate settings
                    </div>
                </div>
                <div className="col-12 mt-3 d-flex justify-content-between">
                    <div className="d-flex align-items-start">
                        <div className="bg-success-o-30 text-success border-success mt-1 share-icon">
                            <LiaAwardSolid />
                        </div>
                        <div>
                            <div className="font-size-lg">Certificate</div>
                            <div className="text-muted mb-3">
                                would you like to show certificate details
                            </div>
                        </div>
                    </div>
                    <Switch
                        checked={certificateEnabled}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setCertificateEnabled(checked);

                            setPayload((prev) => ({
                                ...prev,
                                share_config: {
                                    ...prev.share_config,
                                    show_certficate: checked,
                                },
                            }));
                            setFinalPayload((prev) => ({
                                ...prev,
                                share_config: {
                                    ...prev.share_config,
                                    show_certficate: checked,
                                },
                            }));
                        }}
                    />
                </div>
                <div className="col-12">
                    <hr className="w-100 m-auto" />
                    <div className="font-weight-bold mt-4">Price settings</div>
                </div>
                <div className="col-12 mt-3 d-flex justify-content-between">
                    <div className="d-flex align-items-start">
                        <div className="bg-primary-o-30 text-primary border-primary mt-1 share-icon">
                            <LiaMoneyBillWaveSolid />
                        </div>
                        <div>
                            <div className="font-size-lg">Current price</div>
                            <div className="text-muted mb-3">
                                would you like to show current price with
                                details
                            </div>
                        </div>
                    </div>
                    <Radio
                        checked={selectedValue === "cost_price"}
                        onChange={handleChange}
                        value="cost_price"
                        name="priceRadio"
                        inputProps={{ "aria-label": "Current Price" }}
                    />
                </div>
                <div className="col-12">
                    {" "}
                    <hr className="w-100 m-auto" />
                </div>
                <div className="col-12 mt-3 d-flex justify-content-between">
                    <div className="d-flex align-items-start">
                        <div className="bg-danger-o-30 text-danger border-danger mt-1 share-icon">
                            <LiaMoneyBillWaveSolid />
                        </div>
                        <div>
                            <div className="font-size-lg">No price</div>
                            <div className="text-muted mb-3">
                                would you like to show no price with details
                            </div>
                        </div>
                    </div>
                    <Radio
                        checked={selectedValue === "no_price"}
                        onChange={handleChange}
                        value="no_price"
                        name="priceRadio"
                        inputProps={{ "aria-label": "No Price" }}
                    />
                </div>
                <div className="col-12">
                    <hr className="w-100 m-auto" />
                </div>

                <div className="col-12 mt-3 d-flex justify-content-between">
                    <div className="d-flex align-items-start">
                        <div className="bg-warning-o-30 text-warning border-warning mt-1 share-icon">
                            <LiaMoneyBillWaveSolid />
                        </div>
                        <div>
                            <div className="font-size-lg">Markup price</div>
                            <div className="text-muted mb-3">
                                would you like to show markup price with details
                            </div>
                        </div>
                    </div>
                    <Radio
                        checked={selectedValue === "mark_up"}
                        onChange={handleChange}
                        value="mark_up"
                        name="priceRadio"
                        inputProps={{ "aria-label": "Markup Price" }}
                    />
                </div>
                {/* <hr  className='w-75 m-auto'/> */}

                <div className="col-12 ">
                    <div
                        className={`markup-price-div form-group mb-2 ${
                            selectedValue === "mark_up" ? "show" : ""
                        }`}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className=" mb-2">
                                Markup Setting (IN{" "}
                                {data?.ourPriceShareExchangeSymbolName})
                            </div>
                            <div className="d-flex align-items-center">
                                <span className="text-muted small">
                                    Absolute
                                </span>
                                <Switch
                                    color="primary"
                                    size="small"
                                    checked={markupType}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setMarkupType(checked);
                                        setPayload((prev) => ({
                                            ...prev,
                                            share_config: {
                                                ...prev.share_config,
                                                markup_type: checked
                                                    ? "percentage"
                                                    : "absolute",
                                            },
                                        }));
                                        setFinalPayload((prev) => ({
                                            ...prev,
                                            share_config: {
                                                ...prev.share_config,
                                                markup_type: checked
                                                    ? "percentage"
                                                    : "absolute",
                                            },
                                        }));
                                    }}
                                />
                                <span className="text-muted small">
                                    Percentage %
                                </span>
                            </div>
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text text-muted font-size-lg bg-white border-right-0 pl-3 pr-0 py-2">
                                    {markupType
                                        ? "%"
                                        : data?.ourPriceShareExchangeSymbol}
                                </span>
                            </div>

                            <input
                                type="number"
                                id="markupInput"
                                name="markupInput"
                                value={markupValue}
                                className="form-control border-left-0"
                                placeholder="Enter markup value"
                                onChange={(e) => setMarkupValue(e.target.value)}
                            />
                        </div>

                        {markupError ? (
                            <span className="small text-danger">
                                {markupError}
                            </span>
                        ) : null}
                        <hr className="w-100 my-5" />
                    </div>
                    <div className="input-group mb-3 date-input flex-nowrap">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white border-right-0 pl-3 pr-2">
                                <IoCalendarOutline
                                    className="text-muted"
                                    size={18}
                                />
                            </span>
                        </div>

                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select Expiration date (DD/MM/YYYY)"
                            className={`form-control border-left-0 ${
                                startDate ? "border-right-0 rounded-0" : ""
                            }`}
                        />

                        {startDate && (
                            <div className="input-group-append">
                                <span
                                    className="input-group-text bg-white border-left-0"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setStartDate(null)}
                                >
                                    <IoClose size={18} className="text-muted" />
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white border-right-0 pl-3 pr-0">
                                <IoLockClosedOutline
                                    className="text-muted"
                                    size={18}
                                />
                            </span>
                        </div>

                        <input
                            type="password"
                            name="password"
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control border-left-0"
                            placeholder="Set Password"
                        />
                    </div>
                </div>
                <div className="col-12 text-right mt-5">
                    <button
                        className="btn btn-primary btn-sm px-5 mr-1"
                        onClick={() => {
                            setMount(!mount);
                            onBack();
                        }}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </>
    );
};

export default ShareSetting;
